export default "__VITE_ASSET__Dzq9QphL__"